import { globalBreak } from "@/styles/break";
import { getElementHeight } from "@/utils/getELementHeight";
import { resBreak } from "@/utils/resBreak";
import { SxProps } from "@mui/material";
import { ZIndex } from "@mui/material/styles";

export const PdpProductNameAndDetailsSX:SxProps = {
    py:2.5,
}

export const ccSectionObsRefSX = ({isSticky}:{isSticky:boolean}): SxProps => ({
    mt:'0px !important',
    height: globalBreak({mobile:0, desktop: isSticky ? getElementHeight("#add_product_to_cart_section") : 0})
})

export const PdpAddToCartSectionSX = ({ isSticky, zIndex }: { zIndex:ZIndex, isSticky?: boolean }): SxProps => ({
    position: isSticky ? 'fixed' : 'static',
    top: isSticky ? globalBreak({mobile:'unset', desktop:0}) : 'auto',
    bottom: isSticky ? globalBreak({mobile:'0', desktop:'unset'}) : 'auto',
    right: isSticky ? globalBreak({mobile:'0', desktop:'unset'}) : 'auto',
    width: isSticky ? globalBreak({mobile:'100%', desktop:'40vw', desktopL:'30%', desktopXL:'30%' }) : 'inherit',
    background: '#fff',
    zIndex: isSticky ? zIndex.PdpDeliverySection : 'unset',
    boxShadow: isSticky ? '0 2px 5px rgba(0,0,0,0.1)' : 'none',
    rowGap:isSticky ? 1.5 : 3,
    p:isSticky ? 1 : 0,
    pt:isSticky ? globalBreak({mobile:2, desktop:1}) : 0,
    '& .MuiRadio-root':{
        pt: isSticky ? globalBreak({mobile:0.25, desktop:1}) : globalBreak({mobile:0.5, desktop:1}),
        pb: isSticky ? globalBreak({mobile:0.25, desktop:1}) : globalBreak({mobile:0.5, desktop:1}),
    },
    border:isSticky ? '1px solid #dedede' : 'unset',
    borderRadius: isSticky ? globalBreak({mobile:0, desktop:1}) : 'unset'
})

export const CloseStickA2CartBtnSX: SxProps = {
    position: 'absolute',
    right: 12,
    top: resBreak<'top'>({mobile:'1.2em', desktop:12}),
    '& .MuiSvgIcon-root': {
        fontSize: 29,
    },
    '& .MuiButton-icon':{
        mr:0,
        ml:0
    },
    ':focus-visible':{
        outlineOffset:0
    }
}